import { render, staticRenderFns } from "./collectedManage.vue?vue&type=template&id=2e776402&scoped=true&"
import script from "./collectedManage.vue?vue&type=script&lang=js&"
export * from "./collectedManage.vue?vue&type=script&lang=js&"
import style0 from "./collectedManage.vue?vue&type=style&index=0&id=2e776402&lang=scss&scoped=true&"
import style1 from "./collectedManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e776402",
  null
  
)

export default component.exports